export default __webpack_public_path__ + "static/media/gbm.12d0d68f.png";